import { get, put, post, postFile, del } from '../coreservices/apiService'
import * as environment from '../env_config/environment'
export default function abc() {
  return <div>abc</div>
}

export function GetUserByMobileAndRoleID(mobileNo, roleId) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/auth/get-user-by-mobile-and-roleid/${mobileNo}/${roleId}`;
  return get(url).then(response => response);
}


export function generateOtpmsg91(mobileNumber, purpose , otp, pgid ,referenceId) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/generate-otp/${mobileNumber}/${purpose}/${otp}/${pgid}/${referenceId}`;
  return get(url).then(response => response);
}


// ✅ MSG91 OTP Services
export function sendMsg91Otp(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/send-msg91-otp`;
  return post(url, data).then(response => response);
}

export function verifyMsg91Otp(mobile, otp) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/verify-msg91-otp?mobile=${mobile}&otp=${otp}`;
  return get(url).then(response => response);
}

export function retryMsg91Otp(mobile, retrytype = 'text') {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/retry-msg91-otp?mobile=${mobile}&retrytype=${retrytype}`;
  return get(url).then(response => response);
}



export function forgotPasswordMsg91(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/forgot-password-msg91`;
  return post(url, data).then(response => {
    return response;
  });
}




export function LoginAndGetDashboard(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/auth/login`;
  return post(url, data).then(response => response);
}

export function CreateUser(data) { 
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/auth/insert-user`;
  return post(url, data).then(response => response);
}

export function get_owner_dashboard(pgid) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/dashboard?PGID=${pgid}`
  return get(url).then(response => {
    return response;
  })
}
 
export function get_owner_pg_list(userid) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/get_owner_pg_list/${userid}`;
  return get(url).then(response => {
    return response;
  })
}

export function get_occupancy_status(pgid) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/occupancy-status/${pgid}`;
  return get(url).then(response => {
    return response;
  })
}

export function get_listing_page() {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/listing-page`
  return post(url).then(response => {
    return response;
  })
}

export function getLandingPageForTenant(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/listing-landing-page`;
  return post(url, data).then(response => response);
}

export function getListingLandingPageForTenant(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/listing-landing-page`;
  return post(url, data).then(response => response);
}


export function getLocalities(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/localities`;
  return post(url, data).then(response => {
    return response;
  })
}

export function GetAllElectricityReadings(PGID, RoomId) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/electricity-readings-by-pgid-roomid/${PGID}/${RoomId}`;
  return get(url).then(response => {
    return response;
  })
}

// POST endpoint for tenant page
export function postTenantPage(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/tenant-page`;
  return post(url, data).then(response => response);
}


export function insert_tenant(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/tenantmaster/insert`;
  return post(url, data).then(response => response);
}

export function insert_pgowner_with_files(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/insert`;
  return postFile(url, data).then(response => response);
}

export const insert_tenant_with_files = async (formData) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/tenantmaster/insert`;
  return postFile(url, formData);
}

export function getAmenitiesList(Name) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/amenities-list/${Name}`;
  return get(url).then(response => {
    return response;
  })
}

export function getCategories(type) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/get-categories/${type}`;
  return get(url).then(response => {
    return response;
  })
}

// Get new tenants list
export const getNewTenantList = async (pgId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/new-tenant-list/${pgId}`;
  return get(url).then(response => response);
};

// Get vacant beds by PGID and RoomType
export const getVacantBeds = async (pgId, roomType) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/vacant-beds/${pgId}/${roomType}`;
  return get(url).then(response => response);
};

// get calculated rent by tenantid
export const getRentCalculate = async (TenantID, FromDate, ToDate, RentAmount) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/rent-calculate/${TenantID}/${FromDate}/${ToDate}/${RentAmount}`;
  return get(url).then(response => response);
};

// Update rent and assign bed
export const updateRentAndBed = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/update-rent`;
  return put(url, data).then(response => response);
};

export function roommaster_Insert(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/roommaster/insert`;
  return post(url, data).then(response => response);
}

export function bedmaster_Insert(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/bedmaster/insert`;
  return post(url, data).then(response => {
    return response;
  });
}

export function roommaster_SelectAllActive() {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/roommaster/all`
  return get(url).then(response => {
    return response;
  })
}

export function roommaster_SelectByPGID(pgid) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/roommaster/pg/${pgid}`
  return get(url).then(response => {
    return response;
  })
}


export const getRoomTypes = async () => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/roommaster/room-types`;
  return get(url).then(response => response);
};


export const getAllComplaintsByPGID = async (PGID) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/complaintmaster/complaints/${PGID}`;
  return get(url).then(response => response);
};

export function update_complaint_status(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/complaintmaster/update-complaint-status`;
  return put(url, data).then(response => {
    return response;
  });
}


// Update compliance status
export const updateComplianceStatus = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/compliancemaster/update-compliance-status`;
  return put(url, data).then(response => response);
};

export const getComplaintsByTenantId = async (tenantId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/complaintmaster/tenant/${tenantId}`;
  return get(url).then(response => response);
};

export const getAllComplianceByPGID = async (pgId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/compliancemaster/compliance/${pgId}`;
  return get(url).then(response => response);
};

export const getTenantRegisterByAdmission = async (pgId, admissionId, fromDate, toDate) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/tenantmaster/getTenantRegisterByAdmission/${pgId}/${admissionId}/${fromDate}/${toDate}`;
  return get(url).then(response => response);
};


export const GetComplianceByTenant = async (TenantID) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/compliancemaster/tenant/${TenantID}`;
  return get(url).then(response => response);
};

export const insertComplaint = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/complaintmaster/insert`;
  return post(url, data).then(response => response);
}; 

export const insertCompliance = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/compliancemaster/insert`;
  return post(url, data).then(response => response);
};

export const process_rent_payment = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/tenantmaster/process-rent-payment`;
  return post(url, data).then(response => response);
};

export const insertElectricityReading = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/electricity-reading`;
  return post(url, data).then(response => response);
};

// Get Electricity Reading by Month and Year
export const getElectricityByMonthYear = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/get-electricity-reading/get`;
  return post(url, data).then(response => response);
};

export const GetPreviousMonthReadingValue = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/get-previous-electricity-reading/get`;
  return post(url, data).then(response => response);
};

// Send form link to tenant email
export const sendTenantFormLink = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/send-form-link`;
  return post(url, data).then(response => response);
};

export const sendQRCode = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/send-qr-code`;
  return post(url, data).then(response => response);
};

export const getPGById = async (pgId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/${pgId}`;
  return get(url).then(response => response);
};


export const getPGRevenueStatus = async (pgId, CurrDate) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/revenue-status/${pgId}/${CurrDate}`;
  return get(url).then(response => response);
};

export const autoGenerateRent = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/auto-generate-rent`;
  return post(url, data).then(response => response);
};


export const autoGenerateElectricityBill = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/auto-generate-electricity-bill`;
  return post(url, data).then(response => response);
};

export const getTenantStatement = async (AdmissionId, PGID) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/tenant-statement/${AdmissionId}/${PGID}`;
  return get(url).then(response => {
    return response;
  })
}


export const tenantCheckout = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/tenant-checkout`;
  return post(url, data).then(response => {
    return response;
  })
}





// Add to your pgApi.js file

// Insert Property Photo
export const insertPropertyPhoto = async (formData) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgphotos/insert`;
  return postFile(url, formData).then(response => {
    return response;
  });
};

// Get Property Photos
export const getPropertyPhotos = async (PGID, RoomID = null, BedID = null, Status = null) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgphotos/get/${PGID}`;
  const params = {};
  if (RoomID) params.RoomID = RoomID;
  if (BedID) params.BedID = BedID;
  if (Status) params.Status = Status;

  const queryString = new URLSearchParams(params).toString();
  if (queryString) url += `?${queryString}`;

  return get(url).then(response => {
    return response;
  });
};

// Get Property Photo By ID
export const getPropertyPhotoById = async (PhotoID) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgphotos/get-by-id/${PhotoID}`;
  return get(url).then(response => {
    return response;
  });
};

// Update Property Photo
export const updatePropertyPhoto = async (PhotoID, data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgphotos/update/${PhotoID}`;
  return put(url, data).then(response => {
    return response;
  });
};

// Update Photo Order
export const updatePhotoOrder = async (PhotoID, DisplayOrder) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgphotos/update-order`;
  return put(url, { PhotoID, DisplayOrder }).then(response => {
    return response;
  });
};

// Set Primary Photo
export const setPrimaryPhoto = async (PhotoID) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgphotos/set-primary`;
  return put(url, { PhotoID }).then(response => {
    return response;
  });
};

// Delete Property Photo
export const deletePropertyPhoto = async (PhotoID) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgphotos/delete/${PhotoID}`;
  return del(url).then(response => {
    return response;
  });
};




// Create Visit Booking
export function createVisitBooking(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/visit-master/create-booking`;
  return post(url, data).then(response => {
    return response;
  })
}

// Resend OTP
export function resendOTP(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/visit-master/resend-otp`;
  return post(url, data).then(response => {
    return response;
  })
}

// Verify OTP
export function verifyOTP(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/visit-master/verify-otp`;
  return post(url, data).then(response => {
    return response;
  })
}

export function verifyOTPAgreement(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/verify-otp`;
  return post(url, data).then(response => {
    return response;
  })
}

// Cancel Booking
export function cancelBooking(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/visit-master/cancel-booking`;
  return post(url, data).then(response => {
    return response;
  })
}

// Get Booking Details
export function getBookingDetails(bookingId) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/visit-master/booking/${bookingId}`;
  return get(url).then(response => {
    return response;
  });
}

export const GetPGIDByBarcodeId = async (BarcodeId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/GetPGIDByBarcodeId/${BarcodeId}`;
  return get(url).then(response => response);
};


// Generate OTP
export function generateOTP(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/generate-otp`;
  return post(url, data).then(response => {
    return response;
  });
}

// Forgot Password - Reset password using OTP
export function forgotPassword(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/otp/forgot-password`;
  return post(url, data).then(response => {
    return response;
  });
}



export const getStates = async (stateName) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/states/${stateName}`;
  return get(url).then(response => response);
};


export const getCitiesByStateId = async (stateId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/cities-by-state-id/${stateId}`;
  return get(url).then(response => response);
};


export const getLocalitiesByCityId = async (cityId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/pgmaster/localities-by-city-id/${cityId}`;
  return get(url).then(response => response);
};












// // ─── Food Menu APIs ────────────────────────────────────────────────────

// /**
//  * Save Food Menu Template
//  * POST /foodmenumaster/save-template
//  */
// export function saveFoodMenuTemplate(data) {
//   let apiUrl = environment.apiUrl;
//   let url = `${apiUrl}/foodmenumaster/save-template`;
//   return post(url, data).then(response => response);
// }

// /**
//  * Save Daily Food Menu
//  * POST /foodmenumaster/save-daily
//  */
// export function saveDailyFoodMenu(data) {
//   let apiUrl = environment.apiUrl;
//   let url = `${apiUrl}/foodmenumaster/save-daily`;
//   return post(url, data).then(response => response);
// }

// /**
//  * Get Today's Food Menu
//  * GET /foodmenumaster/today/:pgId/:menuDate
//  */
// export function getTodayFoodMenu(PGID, MenuDate) {
//   let apiUrl = environment.apiUrl;
//   let url = `${apiUrl}/foodmenumaster/today/${PGID}/${MenuDate}`;
//   return get(url).then(response => response);
// }

// /**
//  * Get food-template-weekly Food Menu
//  * GET /foodmenumaster/food-template-weekly/:pgId/:menuDate
//  */
// export function getWeeklyFoodMenu(PGID, MenuDate) {
//   let apiUrl = environment.apiUrl;
//   let url = `${apiUrl}/foodmenumaster/food-template-weekly/${PGID}/${MenuDate}`;
//   return get(url).then(response => response);
// }

// /**
//  * Delete Food Menu (Soft Delete)
//  * DELETE /foodmenumaster/:menuId
//  */
// export function deleteFoodMenu(MenuID) {
//   let apiUrl = environment.apiUrl;
//   let url = `${apiUrl}/foodmenumaster/${MenuID}`;
//   return del(url).then(response => response);
// }


// ─── Food Menu APIs ────────────────────────────────────────────────────

/**
 * Save Food Menu Template
 * POST /foodmenumaster/save-template
 */
export function saveFoodMenuTemplate(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/foodmenumaster/save-template`;
  return post(url, data).then(response => response);
}

/**
 * Save Daily Food Menu
 * POST /foodmenumaster/save-daily
 */
export function saveDailyFoodMenu(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/foodmenumaster/save-daily`;
  return post(url, data).then(response => response);
}

/**
 * Get Today's Food Menu
 * GET /foodmenumaster/today/:pgId/:menuDate
 */
export function getTodayFoodMenu(PGID, MenuDate) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/foodmenumaster/today/${PGID}/${MenuDate}`;
  return get(url).then(response => response);
}

/**
 * Get weekly food menu
 * GET /foodmenumaster/food-template-weekly/:pgId
 * Optional query param: ?menuDate=YYYY-MM-DD
 */
export function getWeeklyFoodMenu(PGID, MenuDate) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/foodmenumaster/food-template-weekly/${PGID}`;
  if (MenuDate) {
    url += `?menuDate=${MenuDate}`;
  }
  return get(url).then(response => response);
}

/**
 * Delete Food Menu (Soft Delete)
 * DELETE /foodmenumaster/:menuId
 */
export function deleteFoodMenu(MenuID) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/foodmenumaster/${MenuID}`;
  return del(url).then(response => response);
}

// ─── Tenant Security Deposit APIs ────────────────────────────────────

/**
 * Insert Security Deposit
 * POST /tenant-security-deposit/insert
 */
export function insertSecurityDeposit(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/securitydepositmaster/insert`;
  return post(url, data).then(response => response);
}



/**
 * Receive Security Deposit
 * PUT /tenant-security-deposit/receive
 */
export function receiveSecurityDeposit(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/securitydepositmaster/receive`;
  return put(url, data).then(response => response);
}

/**
 * Adjust Security Deposit
 * PUT /tenant-security-deposit/adjust
 */
export function adjustSecurityDeposit(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/securitydepositmaster/adjust`;
  return put(url, data).then(response => response);
}

/**
 * Refund Security Deposit
 * PUT /tenant-security-deposit/refund
 */
export function refundSecurityDeposit(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/securitydepositmaster/refund`;
  return put(url, data).then(response => response);
}

/**
 * Get Security Deposit Details
 * GET /tenant-security-deposit/:admissionId
 */
export function getSecurityDeposit(AdmissionID) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/securitydepositmaster/${AdmissionID}`;
  // let url = `${apiUrl}/securitydepositmaster/378`;
  return get(url).then(response => response);
}









// ─── Expense APIs ────────────────────────────────────────────────────

/**
 * Save Tenant Expense (Create or Update)
 * POST /expensemaster/save-expense
 */
export function saveTenantExpense(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/expensemaster/save-expense`;
  return post(url, data).then(response => response);
}


/**
 * Save Tenant Expense receive
 * POST /expensemaster/save-expense
 */
export function receiveTenantExpense(data) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/expensemaster/receive-expense`;
  return post(url, data).then(response => response);
}



/**
 * Get Tenant Pending Expenses
 * GET /expensemaster/pending-expenses/:pgId/:admissionId
 */
export function getTenantPendingExpenses(PGID, AdmissionID) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/expensemaster/pending-expenses/${PGID}/${AdmissionID}`;
  // let url = `${apiUrl}/expensemaster/pending-expenses/5155/326`;
  return get(url).then(response => response);
}

/**
 * Get Tenant Expense Report
 * GET /expensemaster/expense-report/:pgId/:fromDate/:toDate
 */
export function getTenantExpenseReport(PGID, FromDate, ToDate) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/expensemaster/expense-report/${PGID}/${FromDate}/${ToDate}`;
  return get(url).then(response => response);
}

/**
 * Pay Tenant Expense
 * PUT /expensemaster/pay-expense/:expenseId/:transactionId
 */
export function payTenantExpense(ExpenseID, TransactionID) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/expensemaster/pay-expense/${ExpenseID}/${TransactionID}`;
  return put(url, {}).then(response => response);
}

/**
 * Search Tenants for PG (for dropdown)
 * GET /tenant/search/:pgId
 */
export function searchTenantsForPG(PGID) {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/expensemaster/search/${PGID}`;
  return get(url).then(response => response);
}

/**
 * Get Expense Types
 * GET /expensemaster/expense-types
 */
export function getExpenseTypes() {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/expensemaster/expense-types`;
  return get(url).then(response => response);
}


export const getSettlement = async (admissionId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/settlement/${admissionId}`;
  return get(url).then(response => response);
};

export const generateSettlement = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/settlement/generate`;
  return post(url, data).then(response => response);
};

export const processSettlement = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/settlement/process`;
  return post(url, data).then(response => response);
};

export const processOverallPayment = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/settlement/overall-payment`;
  return post(url, data).then(response => response);
};

export const getOverallDue = async (admissionId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/settlement/overall-due/${admissionId}`;
  return get(url).then(response => response);
};



// reports api functions

/**
 * Get Occupancy Report
 * GET /report/occupancy-report/:pgId/:fromDate/:toDate
 */
export const getOccupancyReport = async (pgId, fromDate, toDate) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/report/occupancy-report/${pgId}/${fromDate}/${toDate}`;
  return get(url).then(response => response);
};

export const tenantNoticeInsert = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/tenantnotice/insert`;
  return post(url, data).then(response => response);
};

// export const getTenantNotices = async (noticeId = null, admissionId = null) => {
//   let apiUrl = environment.apiUrl;
//   let url = `${apiUrl}/tenantnotice/select`;
  
//   // Add query parameters if provided
//   const params = new URLSearchParams();
//   if (noticeId) params.append('noticeId', noticeId);
//   if (admissionId) params.append('admissionId', admissionId);
  
//   if (params.toString()) {
//     url += `?${params.toString()}`;
//   }
  
//   return get(url).then(response => response);
// };


  
export const getTenantNoticeByAdmission = async (admissionId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/tenantnotice/select?admissionId=${admissionId}`;
  return get(url).then(response => response);
};
/**
 * Get Revenue Report
 * GET /report/revenue-status-report/:pgId/:fromDate/:toDate
 */
export const getRevenueReport = async (pgId, fromDate, toDate) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/report/revenue-status-report/${pgId}/${fromDate}/${toDate}`;
  return get(url).then(response => response);
};

export const sendWhatsAppOverdueReminder = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/whatsapp/overdue/send`;
  return post(url, data).then(response => response);
};



// Create a new rent agreement
export const createRentAgreement = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/agreement/create`;
  return post(url, data).then(response => response);
};

// Accept a rent agreement with OTP verification
export const acceptRentAgreement = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/agreement/accept`;
  return put(url, data).then(response => response);
};

// Reject a rent agreement with reason
export const rejectRentAgreement = async (data) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/agreement/reject`;
  return put(url, data).then(response => response);
};

// Generate and save PDF for an agreement
export const generateAgreementPDF = async (agreementId, file, isVerified = false) => {
   let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/agreement/generate-pdf`;
  
  const formData = new FormData();
  formData.append('file', file);
  formData.append('AgreementID', agreementId.toString());
  // formData.append('IsVerified', isVerified.toString());

  return postFile(url, formData).then(response => response);
};

// Download agreement details with document info
export const downloadAgreement = async (agreementId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/agreement/download/${agreementId}`;
  return get(url).then(response => response);
};

// get agreement json data
export const getAgreementJsonData = async (pgId, tenantId) => {
  let apiUrl = environment.apiUrl;
  let url = `${apiUrl}/agreement/get-agreement-json-data?pgId=${pgId}&tenantId=${tenantId}`;
  return get(url).then(response => response);
};